import { readCache } from "@/store/action"
import { getUserMeQueryKey, getUserStateQueryKey } from "@/client/@tanstack/react-query.gen"
import type { GetUserMeResponse, GetUserStateResponse } from "@/client"

export const getUserInfo = () => { //Read userInfo cache
  const data = readCache(getUserMeQueryKey()) as GetUserMeResponse
  return data
}

export const getUserState = () => {
  const data = readCache(getUserStateQueryKey()) as GetUserStateResponse
  return data
}
